import { defineComponent as _defineComponent } from 'vue'
import { IArrivalTimeOption } from "@/domain/entities/lineInfo";
import { ArrivalTimeOptionCode } from "@/types";
import useGetAccessToken from "@/use/useGetAccessToken";
import { computed, PropType, ref } from "vue";
import InlineSvg from "vue-inline-svg";


const __default__ = {
  name: "BusArrivalTimeSelect",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isAllocExisted: {
    type: Boolean,
    required: true,
  },
  selectedOption: {
    type: Object as PropType<IArrivalTimeOption>,
    default: () => ({
      name: "목표도착시각",
      type: ArrivalTimeOptionCode.STANDARD,
    }),
  },
  options: {
    type: Array as PropType<IArrivalTimeOption[]>,
    default: () => [],
  },
  isInsideShuttle: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onChangeOption", "onSelectPastTimeOption"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;

const handleChangeOption = (option: IArrivalTimeOption) => {
  toggleShowOptionWrapper(false);
  emit("onChangeOption", option);
};

/** 로그인 여부 */
const isLoggedIn = computed(() => !!useGetAccessToken());

/** option선택창 보이기 여부 */
const shouldShowOptionWrapper = ref(false);

const toggleShowOptionWrapper = (show: boolean) => {
  shouldShowOptionWrapper.value = show;
};

/** '목표도착시각' 등 Select 텍스트 클릭 시, 핸들링 */
const handleClickTimeSelect = () => {
  // 로그인 한 경우에만, '표시 시간 옵션' 선택 가능
  if (!isLoggedIn.value) return;

  toggleShowOptionWrapper(!shouldShowOptionWrapper.value);
};

const __returned__ = { emit, handleChangeOption, isLoggedIn, shouldShowOptionWrapper, toggleShowOptionWrapper, handleClickTimeSelect, get ArrivalTimeOptionCode() { return ArrivalTimeOptionCode }, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})